module.exports = __webpack_public_path__ + "img/product_53.cd84c27.webp";